import GeneralActions from './general.actions';

import TypeDefautRepository from '../repositories/type-defaut.repository';

export const REQUEST_TYPE_DEFAUT = 'REQUEST_TYPE_DEFAUT';
export const RECEIVE_TYPE_DEFAUT = 'RECEIVE_TYPE_DEFAUT';
export const FAILURE_TYPE_DEFAUT = 'FAILURE_TYPE_DEFAUT';

function failureTypeDefaut() {
  return {
    type: FAILURE_TYPE_DEFAUT,
    payload: {}
  };
}

function receiveTypeDefaut(data) {
  return {
    type: RECEIVE_TYPE_DEFAUT,
    payload: {
      data
    }
  };
}

function requestTypeDefaut() {
  return {
    type: REQUEST_TYPE_DEFAUT,
    payload: {}
  };
}

function loadData() {
  return (dispatch, getState) => {
    if (getState().typeDefaut.fetching || getState().typeDefaut.data) {
      // Chargement en cours ou on a des données, on ne fait rien
      return;
    }
    dispatch(GeneralActions.taskStarted());
    dispatch(requestTypeDefaut());
    TypeDefautRepository.load()
      .then((response) => {
        dispatch(GeneralActions.taskDone());
        dispatch(receiveTypeDefaut(response.data));
      }, () => {
        dispatch(GeneralActions.taskFailed());
        dispatch(failureTypeDefaut());
      });
  };
}

export default {
  loadData
};



// WEBPACK FOOTER //
// ./src/actions/type-defaut.actions.js